export const Regexes = {
  PERSIAN_CHARACTERS: /^[\u0600-\u06FF\s]+$/,
  NUMBERS: /^[\d0-9۰-۹]*$/,
  FLOAT_NUMBERS: /^[\d۰-۹]+([.,٫][\d۰-۹]+)?$/,
  NOT_NUMBERS: /[^0-9۰-۹]/g,
  PHONE_NUMBER: /^09[0-9]{9}$/,
  HOME_NUMBER: /^0\d{2,3}\d{7,8}$/,
  SHEBA: /^(ir|IR)?\d$/,
  EMAIL: /^[\w.+-]+@([\w-]+\.)+[A-Za-z]{2,}$/,
}
